import {encode} from "../helpers/column_names";
import {pasteCondition} from "./conditional_formats";
import group from "./undo_group";

export function init(view){
	var table = view._table;

	var bs = 0;
	table.attachEvent("onAreaDrag", () => bs = new Date());
	table.attachEvent("onBeforeAreaRemove", function(){
		//[FIXME] currently we don't have enough info to know
		//is user selects new area, and removing need to be blocked
		//or is it some API which attempts to remove the area
		if (view.$handleSelection && (new Date() - bs)<500) return false;
	});

	table.attachEvent("onBeforeAreaAdd", (area) => {
		//[FIXME] 
		//block selection of row-id column
		//temporary fix, we need to fire onBeforeBlockSelect when selection moves
		//so the common onBeforeBlockSelect handler will block rowId selection
		if (area.start.column == "rowId") return false;

		//if we have an active editor, we need to close it on block selection
		//ignore, when selecting the editor's cell
		var editor = table.getEditor();
		if (editor && (
			editor.row != area.start.row || editor.column != area.start.column ||
			editor.row != area.start.row || editor.column != area.start.column ))
			table.editStop();

		if (!view.$handleSelection) return true;
		

		let blockStart = encode[area.start.column] + area.start.row;
		let blockEnd = encode[area.end.column] + area.end.row;

		var res = view.$handleSelection(area.start, area.end, blockStart, blockEnd);

		if (res !== false){
			view.$handleSelection = null;
			table.removeSelectArea();
		}

		return res;
	});

	table.attachEvent("onBeforeBlockSelect", (start, end, finalStep) => {
		if(finalStep && table.$handleStart){
			const oldSel = table.getSelectArea();
			const oldStart = oldSel.start;
			const oldEnd = oldSel.end;

			const sr = start.row;
			const er = end.row;
			const sc = start.column;
			const ec = end.column;

			if(oldStart.row == sr && oldEnd.row > er)
				view.clearRange({start:{row:er+1,column:sc}, end:{row:oldEnd.row,column:ec}}, {values:true});
			else if(oldStart.column == sc && oldEnd.column > ec){
				view.clearRange({start:{row:sr,column:ec+1}, end:{row:er,column:oldEnd.column}}, {values:true});
			}
			else{
				let type;
				if(sr != oldStart.row || er != oldEnd.row)
					type = "row";
				else if(sc != oldStart.column || ec != oldEnd.column)
					type = "column";

				if(type){
					group.start();
					const isRow = type == "row";
					for (
						let i = (isRow ? sc : sr);
						i <= (isRow ? ec : er);
						i++
					){
						const nums = [];
						let border = [];
						for (let j = oldStart[type]; j <= oldEnd[type]; j++) {
							const [row, col] = type == "row" ? [j, i] : [i, j];
							const value = view.getCellValue(row, col);
							if(webix.rules.isNumber(value)){
								if(!border[0]){
									border.firstValue = value;
									border[0] = border[1] = j;
								}
								else{
									border[1] = j;
									if(webix.isUndefined(border.inc))
										border.inc = value - border.firstValue;
								}
								nums[j] = border;
							}
							else
								border = [];
						}

						const afterSel = oldStart[type] == (isRow ? sr : sc);
						const start = afterSel ? oldStart[type] : oldEnd[type];
						const dir = afterSel ? 1 : -1;

						for(
							let j = (afterSel ? oldEnd[type] + 1 : oldStart[type] - 1), index = 0, iteration = 1;
							afterSel ? j <= (isRow ? er : ec) : j >= (isRow ? sr : sc);
							afterSel ? j++ : j--, index++
						){
							if(index == oldEnd[type] - oldStart[type] + 1){
								iteration++;
								index = 0;
							}

							const linkPos = start+index*dir;
							const [linkRow, linkCol] = isRow ? [linkPos, i] : [i, linkPos];

							let value = view.getCellValue(linkRow, linkCol);

							const num = nums[linkPos];
							if(num)
								value += (num.inc || 1) * (num[1] - num[0] + 1) * iteration * dir;

							else if(typeof value == "string" && value[0] == "=" && value.length > 0){
								if(isRow)
									value = view._mData.getStore().transposeMath(value, j - start - index * dir, 0);
								else
									value = view._mData.getStore().transposeMath(value, 0, j - start - index * dir);
							}

							const [row, col] = isRow ? [j, i] : [i, j];
							view.setCellValue(row, col, value);
							view.setStyle(row, col, view.getStyle(linkRow, linkCol));

							const condition = view.conditions.get(linkRow, linkCol);
							if(condition)
								pasteCondition(view, {condition}, row, col);
							else
								view.conditions.clear(row, col);
						}
					}
					group.end();
				}
			}
		}
	});

	webix.event(table.$view, "mousedown", function(e){
		if (view.$handleSelection)
			return webix.html.preventEvent(e);
	});
}
